// extracted by mini-css-extract-plugin
export default {"videoPreview":"videoPreview__VE14H","videoPlaceholder":"videoPlaceholder__rFjV8","videoEffectsButton":"videoEffectsButton__Xj2YD"};